import {getPromotionDropdownValues} from '@/services/PromotionsService/promotionProductSelection'
import {useQuery} from '@tanstack/react-query'

// A dedicated hook for fetching category / sub-category dropdown values
export const useGetCategoryDropdown = (dropDownType = '') => {
  const query = useQuery({
    queryKey: ['categoryDropdown', dropDownType],
    queryFn: () => getPromotionDropdownValues(dropDownType),
    enabled: !!dropDownType,
    initialData: {data: []},
  })

  return query
} 